SupportGeneralPopupTemplate = require('../../../general_popup.html.mustache')
Backbone = require 'backbone'
Backbone.$ = $

class SupportRedemptionInstructionsPopupView extends Backbone.View

  initialize: ->
    _.bindAll.apply(_, [this].concat(_.functions(this)))
    @I18nScope = 'modules.support'
    @template = SupportGeneralPopupTemplate
    @order = Groupon.Support.currentOrder

  render: ->
    @popup = $('#popup')
    GIG.Modal.open
      el: @popup
      closeOnBgClick: true
      closeOnEscKey: true
    @$el.html toHtml(@template, @toHash(), @I18nScope)
    @popup.html(this.el)
    openLinksInNewTab($('#popupContent a'))

  toHash: ->
    obj =
      title: I18n.t("js.modules.support.redemption_instructions")
      instructions: replaceNewLineWithBreak(@order.dealOption.instructions)

  closeModal: ->
    GIG.Modal.close()
    return false

  events:
    'click .close-modal' : "closeModal"

module.exports = SupportRedemptionInstructionsPopupView
